export const baseApiEndpoint =
  import.meta.env.VITE_APP_BASE_URL || 'https://stg.vimc.fafu.com.vn/api/v1';
export const baseApiTrucEndpoint =
  import.meta.env.VITE_APP_API_URL_TRUC ||
  'https://stg.truc-vimc.fafu.com.vn/api/v1';

export const USE_SSO = import.meta.env.VITE_APP_USE_SSO === 'true';
